var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import cs from 'classnames';
import { useChatUnreadStore } from 'common/services/chat-unread-service/service-store/service-store';
import { chatUnreadServiceUnreadMessagesCountSelector } from 'common/services/chat-unread-service/service-store/selectors';
import styles from './chats-menu-section-link.module.scss';
var getActiveClassName = function (cb) {
    return function (_a) {
        var _b;
        var isActive = _a.isActive;
        isActive && (cb === null || cb === void 0 ? void 0 : cb());
        return cs(styles.menuSectionLink, (_b = {}, _b[styles.active] = isActive, _b));
    };
};
export var ChatsMenuSectionLink = memo(function (_a) {
    var to = _a.to, label = _a.label, IconComponent = _a.icon, openSection = _a.openSection;
    var unreadMessagesCount = useChatUnreadStore(chatUnreadServiceUnreadMessagesCountSelector);
    return (_jsxs(NavLink, __assign({ className: getActiveClassName(openSection), to: to, end: to === '/' || true }, { children: [IconComponent && _jsx(IconComponent, { className: styles.icon, width: "1.25rem", height: "1.25rem", viewBox: "0 0 20 20" }), _jsx("span", __assign({ className: styles.label }, { children: label })), unreadMessagesCount > 0 ? (_jsx("span", __assign({ className: styles.unreadCount }, { children: unreadMessagesCount > 99 ? '99+' : unreadMessagesCount }))) : null] })));
});
